export type { FeaturedAndSortedPortalsState } from './reducer';
export { featuredAndSortedPortalsReducer, emptyFeaturedAndSortedPortalsState } from './reducer';
